import { render, staticRenderFns } from "./withdrawrequest.vue?vue&type=template&id=bfaecab0&scoped=true&"
import script from "./withdrawrequest.vue?vue&type=script&lang=js&"
export * from "./withdrawrequest.vue?vue&type=script&lang=js&"
import style0 from "./withdrawrequest.vue?vue&type=style&index=0&id=bfaecab0&lang=less&scoped=true&"
import style1 from "./withdrawrequest.vue?vue&type=style&index=1&id=bfaecab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaecab0",
  null
  
)

export default component.exports